import ReactGA from "react-ga4";
import posthog from "posthog-js";

let initialized = false;

export const initGA = () => {
  if (initialized) return;

  ReactGA.initialize("G-V5EZ6E37JH");

  posthog.init("phc_d1DTQIzBwsbh9E7bFH7J6HsxflWR2KtFsfBuWxqYuD1", {
    api_host: "https://us.i.posthog.com",
    defaults: "2026-01-30",
  });

  initialized = true;
};

export const trackPageview = (path) => {
  ReactGA.send({
    hitType: "pageview",
    page: path,
  });

  posthog.capture("$pageview", {
    path,
  });
};

export const trackEvent = (eventName, properties = {}) => {
  ReactGA.event(eventName, properties);
  posthog.capture(eventName, properties);
};